import { GenderEnum } from "@utilities/enums";
import { ImageType } from "./imageType";

export type User = Omit<UserBaseType, 'salt' | 'password'>

type UserBaseType = Readonly<{ // modifier si jamais y a pb
    _id: string
    _organisationId: string
    role: UserShopRoleEnum
    email: string
    avatar?: ImageType
    gender?: GenderEnum
    token?: string
    salt?: string
    firstname?: string
    lastname?: string
    phone?: string
    birthDate?: Date
    password?: string
    phoneVerify?: boolean
    emailVerify?: boolean
    lastLoginAt?: Date
    createAt?: Date
}>

export type CreateUserType = {
    email: string;
    role: UserShopRoleEnum;
    organisationID?: string
}
export enum UserShopRoleEnum {
    admin = 'admin',
    subAdmin = 'sous-admin',
    seller = 'vendeur(se)',
}